import { render, staticRenderFns } from "./SlotGamesList.vue?vue&type=template&id=2015c366&"
import script from "./SlotGamesList.vue?vue&type=script&lang=js&"
export * from "./SlotGamesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports